import { render, staticRenderFns } from "./limits.vue?vue&type=template&id=33a6720a&"
import script from "./limits.vue?vue&type=script&lang=js&"
export * from "./limits.vue?vue&type=script&lang=js&"
import style0 from "./limits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports